import { IOfferSpendByOfferScopeDetailsTableLang } from '../../../types/lang'

export const offerSpendByOfferScopeDetailsTableLang: IOfferSpendByOfferScopeDetailsTableLang = {
	offer_spend_by_offer_scope_details_table: {
		column_id: 'ID',
		column_date: 'Date',
		column_amount: 'Amount',
		column_account: 'Account',
		column_kt_group: 'KT Group',
		column_offer: 'Offer',
		column_notes: 'Notes',
	}
}